import { OrganizationCode } from 'merchandising-sdk';

export const environment = {
  production: false,
  organization: OrganizationCode.LOP,
  is_online: true,
  assets_url: 'https://stmerchstaginglop001.blob.core.windows.net/lop-assets',
  local_db_name: '',
  azure_blob_sas_url: `https://stmerchstaginglop001.blob.core.windows.net/??sv=2021-10-04&ss=btqf&srt=sco&st=2025-12-02T19%3A49%3A35Z&se=2040-12-31T19%3A49%3A00Z&sp=rwdxftlacup&sig=ttAO3LXatnPB6Fl8NobGEtgxPABRVJYT9yegkl5VJ4I%3D`,
  azure_container: `lop-assets`
};